export const MUSCLE_GROUP_OPTIONS = [
  { id: "peito", label: "Peito" },
  { id: "costas", label: "Costas" },
  { id: "ombros", label: "Ombros" },
  { id: "biceps", label: "Bíceps" },
  { id: "triceps", label: "Tríceps" },
  { id: "pernas", label: "Pernas" },
  { id: "quadriceps", label: "Quadríceps" },
  { id: "gluteos", label: "Glúteos" },
  { id: "abdomen", label: "Abdômen" },
  { id: "panturrilha", label: "Panturrilha" },
  { id: "antebraco", label: "Antebraço" },
  { id: "trapezio", label: "Trapézio" },
] as const;
